import { Component, inject, OnInit } from '@angular/core';
import { Populations } from 'src/app/shared/utilities/populations';
import { MarketplaceFacade } from '@fgb/core';

@Component({
  selector: 'fgb-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.scss'],
})
export class EventsPageComponent implements OnInit {
  populations = Populations;
  private marketplaceFacade = inject(MarketplaceFacade);

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItems();
  }
}
